// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f21e5f3d","732":"5faa8717","977":"66a63886"}[chunkId] + ".chunk.js";
};